
import upperCase from 'lodash/upperCase';

import { Drawer, Menu, Tooltip } from 'antd';
import { get, isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
  RootState,
  getPreferenceFromAccount,
  isAnyReservationCancelFromPath,
  DecodeTokenData,
  isSignInFromPath,
  isSignUpFromPath,
  GetHomeParams,
  GetWalletNumber,
} from '@share/utils';
import { logout, setLoginRedirect } from '@share/store/slices';
import { LoginType } from '@share/utils';
import { IAccount, LOGOUT_FIELD_KEY } from '@share/common-types';
import { Routes, USER_BASE_URL } from '@share/constants';
import { NavigationMenu, WhiteButton, ModalInternalization } from '@components';

import { setVisible } from '@share/store/slices';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { Marginator } from '../../marginator';

import './style.scss';

interface IProps {
  matches?: boolean;
  isVacationRentals?: boolean;

  isShowCreditsDrawer: boolean;
}

const ONE = 1;

export function HeaderNavigation(props: IProps) {

  const history = useHistory();
  const intl = useIntl();

  const dispatch = useDispatch();

  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { visible, items, menuList } = menuStore;
  const { account, user, userWallet, userWalletData } = loginStore;

  const showDrawer = () => {
    dispatch(setVisible(!visible));
  };

  const onClose = () => {
    dispatch(setVisible(false));
  };

  const handleLogout = () => {
    dispatch(logout());

    const isPublicAccountType = account?.type === LoginType.Public;
    const hasClientCash = account?.hasClientCash;

    if (!isPublicAccountType || !hasClientCash) {
      hangleGoToLogin();
    }
  };

  const hangleGoToLogin = () => {

    const { pathname, search } = history.location;
    dispatch(setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`));

    history.push(`/${account?.name}${Routes.Login}`);
  };

  const hangleGoToSignUp = () => {
    const { pathname, search } = history.location;
    dispatch(setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`));

    history.push(`/${account?.name}${Routes.SignUp}`);
  };

  const getHeaderColorStyle = () => {

    const styleBackground: any = {};

    const headerFontColor = account?.headerFontColor;
    const headerBackgroundColorDB = account?.headerBackgroundColor;

    if (visible) {
      if (!isEmpty(headerBackgroundColorDB)) {
        styleBackground.backgroundColor = headerBackgroundColorDB;
        document.documentElement.style.setProperty(
          '--header-background-color',
          headerBackgroundColorDB as string,
        );
      } else {
        styleBackground.backgroundColor = '#FFFFFF';
        document.documentElement.style.setProperty('--header-background-color', '#FFFFFF');
      }
    }

    if (!isEmpty(headerFontColor)) {
      styleBackground.color = headerFontColor;
      document.documentElement.style.setProperty('--header-font-color', headerFontColor as string);
    }
    return styleBackground;
  };

  const { SubMenu } = Menu;
  const { matches, isVacationRentals, isShowCreditsDrawer } = props;

  const isCancelRoute = isAnyReservationCancelFromPath(history);
  if (isCancelRoute) {
    return null;
  }

  const isRSITemplate = account?.isRSITemplate;
  const hasClientCash = account?.hasClientCash;
  const headerMainMenu = account?.headerMainMenu;
  const fontFamily = account?.fontFamily;

  const isPublicAccountType = account?.type === LoginType.Public;
  const isPrivateWithLoginAccountType = account?.type === LoginType.PrivateWithLogin;
  const isPrivateWithTokenAccountType = account?.type === LoginType.PrivateWithToken;

  const userNavigation = items?.menu ? items?.menu[items.menu?.length - ONE] : null;

  const styleBackground: any = getHeaderColorStyle();

  const logoutUrlStorage = localStorage.getItem(USER_BASE_URL);
  const logoutUrlToken = get(DecodeTokenData(), 'logoutUrl', null);
  const logoutPref = getPreferenceFromAccount(account as IAccount, LOGOUT_FIELD_KEY);
  const logoutUrl = items?.logoutUrl ?
                        items.logoutUrl : 
                        !isEmpty(logoutUrlStorage) ? 
                            logoutUrlStorage : 
                            !isEmpty(logoutUrlToken) ? 
                                logoutUrlToken : 
                                logoutPref;
                                
  const headerFontColor = !isEmpty(styleBackground?.color) ? styleBackground?.color : '#FFFFFF';
  
  const isWhiteBackgroundColor = !styleBackground?.backgroundColor || styleBackground?.backgroundColor?.toUpperCase() === '#FFFFFF';
  const isWhiteHeaderFontColor = account?.headerFontColor?.toUpperCase() === '#FFFFFF';
  
  const isSignInRoute = isSignInFromPath(history);
  const isSignUpRoute = isSignUpFromPath(history);

  const isLogged = !!userWallet;
  const loggedUser = !hasClientCash ? user : userWallet;
  const homeParams = GetHomeParams(account as IAccount);

  const isRsi = isRSITemplate && account?.isPrivateTokenAccountType;
  const menuItemHideBorderBottom = account?.menuItemHideBorderBottom;

  return (
    <div className={`header__content-navigation ${isRSITemplate ? 'rsi-home' : ''} ${menuItemHideBorderBottom ? 'hide-border' : ''}`}>
      <div
        className={`header__hamburger-btn ${visible ? 'header__show-hamburger-btn' : ''}`}
        onClick={showDrawer}
      >
        <span
          className={`header__hamburger-item ${(isWhiteBackgroundColor && !isWhiteHeaderFontColor) ? 'white' : ''}`}
          style={{ background: headerFontColor }}
        />
        <span
          className={`header__hamburger-item ${(isWhiteBackgroundColor && !isWhiteHeaderFontColor) ? 'white' : ''}`}
          style={{ background: headerFontColor }}
        />
        <span
          className={`header__hamburger-item ${(isWhiteBackgroundColor && !isWhiteHeaderFontColor) ? 'white' : ''}`}
          style={{ background: headerFontColor }}
        />
      </div>
        
      {matches ? (
        <NavigationMenu
          matches={matches}
          menuStore={menuStore}
          isVacationRentals={isVacationRentals}
        />
      ) : (
        <Drawer
          className={`header__navigation ${visible ? 'visible' : ''} ${(isWhiteBackgroundColor) ? 'white' : ''}`}
          width={'100%'}
          closable={true}
          onClose={onClose}
          open={visible}
        >
          <div className="header__navigation-actions">
            <ModalInternalization onOpen={onClose} isDrawer />
            <Marginator onOpen={onClose} />
          </div>

          <NavigationMenu
            matches={matches as boolean}
            menuStore={menuStore}
            isVacationRentals={isVacationRentals}
            isDrawer
            isShowCredits={isShowCreditsDrawer}
          />

          {(!isPublicAccountType || hasClientCash) && (
            <div
              className="header__user-info drawer"
              style={{ ...styleBackground, backgroundColor: '#FFFFFF', marginLeft: '10px', paddingTop: '0px' }}
            >
              {hasClientCash && isLogged ? (
                <>
                  <p className="header__user-drawer-name">
                    {!loggedUser ? items?.firstName : loggedUser?.firstName}{' '}
                    {!loggedUser ? items?.lastName[0] : loggedUser?.lastName}
                  </p>

                  <p className="header__user-drawer-member">
                    <FormattedMessage
                      id="wallet.menu.active_cash"
                      values={{
                        clientCash: isEmpty(account?.walletClientCashName)
                          ? 'Client Cash'
                          : account?.walletClientCashName,
                      }}
                    />
                    {': '}
                    {GetWalletNumber(userWalletData?.balance as number, account)}{' '}
                    <Tooltip
                      title={intl.formatMessage(
                        { id: 'wallet.menu.active_cash.tooltip' },
                        {
                          clientCash: isEmpty(account?.walletClientCashName)
                            ? 'Client Cash'
                            : account?.walletClientCashName,
                        },
                      )}
                    >
                      <FontAwesomeIcon icon={faCircleInfo} />
                    </Tooltip>
                  </p>

                  {!account?.walletIsExternal ? (
                    <p className="header__user-drawer-member" style={{ marginBottom: '20px' }}>
                      <FormattedMessage
                        id="wallet.menu.pending_cash"
                        values={{
                          clientCash: isEmpty(account?.walletClientCashName)
                            ? 'Client Cash'
                            : account?.walletClientCashName,
                        }}
                      />
                      {': '}
                      {GetWalletNumber(userWalletData?.pendingBalance as number, account)}{' '}
                      <Tooltip
                        title={intl.formatMessage(
                          { id: 'wallet.menu.pending_cash.tooltip' },
                          {
                            clientCash: isEmpty(account?.walletClientCashName)
                              ? 'Client Cash'
                              : account?.walletClientCashName,
                          },
                        )}
                      >
                        <FontAwesomeIcon icon={faCircleInfo} />
                      </Tooltip>
                    </p>
                  ) : null}
                </>) : null}

              <Menu mode="inline">
                {isPrivateWithTokenAccountType &&
                !account?.isCapitalVacationsCondoRes &&
                ((!isRSITemplate || items?.showMyAccount) && !((headerMainMenu && menuList?.length))) ? (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`}>
                    <Link
                      className="header__user-drawer-link"
                      to={`/${account?.name}${Routes.RsiAccount}${homeParams}`}
                      onClick={onClose}
                    >
                      <FormattedMessage id={'my.account.title'} />
                    </Link>
                  </Menu.Item>) : null}

                {isPrivateWithTokenAccountType && account?.isCapitalVacations ? (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`}>
                    <Link
                      className="header__user-drawer-link"
                      to={`/${account?.name}${Routes.RsiAccount}/reservations${homeParams}`}
                      onClick={onClose}
                    >
                      <FormattedMessage id={'reservation.search.title'} />
                    </Link>
                  </Menu.Item>) : null}

                {isPrivateWithLoginAccountType ||
                (isPrivateWithTokenAccountType && !account?.isCapitalVacations && !items?.showMyAccount) ||
                (hasClientCash && isLogged && !account?.isCapitalVacations) ? (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`}>
                    <Link
                      className="header__user-drawer-link"
                      to={`/${account?.name}${Routes.Reservations}${homeParams}`}
                      onClick={onClose}
                    >
                      <FormattedMessage id="reservation.search.title" />
                    </Link>
                  </Menu.Item>) : null}


                {!items?.isMLM && !account?.isCapitalVacations && (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`} style={{ ...styleBackground, backgroundColor: '#FFFFFF' }}>
                    <Link
                      className="header__user-drawer-link"
                      to={`/${account?.name}${Routes.SavedPropertiesAccount}${homeParams}`}
                      onClick={onClose}
                    >
                      <FormattedMessage id="saved.properties" />
                    </Link>
                  </Menu.Item>)}

                {!items?.isMLM && !account?.isCapitalVacations && (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`} style={{ ...styleBackground, backgroundColor: '#FFFFFF' }}>
                    <Link
                      className="header__user-drawer-link"
                      to={`/${account?.name}${Routes.ChangePassword}${homeParams}`}
                      onClick={onClose}
                    >
                      <FormattedMessage id="change.password" />
                    </Link>
                  </Menu.Item>)}

                {userNavigation && !userNavigation.childItems ? (
                  <Menu.Item className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`}>
                    {userNavigation?.url === 'disabled' ? (
                      isRsi ? (
                        <Tooltip
                          title={intl.formatMessage({ id: '"menu.link.disable' })}
                          placement="top"
                        >
                          <div
                            style={{ width: '100%' }}
                            className="header__link-nav ant-menu-item-disabled"
                          >
                            <FormattedMessage id={upperCase(userNavigation.title)} />
                          </div>
                        </Tooltip>
                      ) : (
                        upperCase(userNavigation.title)
                      )
                    ) : (
                      <a
                        className="header__link-nav"
                        href={userNavigation.url}
                        onClick={onClose}
                      >
                        {isRsi ? (
                          <FormattedMessage id={upperCase(userNavigation.title)} />
                        ) : (
                          upperCase(userNavigation.title)
                        )}
                      </a>
                    )}
                  </Menu.Item>) : null}

                {userNavigation && userNavigation.childItems ? (
                  <SubMenu
                    title={<FormattedMessage id={upperCase(userNavigation?.title)} />}
                    className={`header__sub-menu ${menuItemHideBorderBottom ? 'hide-border' : ''}`}
                    popupClassName="welcome-menu-submenu-popup"
                  >
                    {userNavigation.childItems?.map((childItem: any, index: number) => (
                      <Menu.Item
                        key={`${childItem.title}-${index}`}
                        className={`header__item-menu ${menuItemHideBorderBottom ? 'hide-border' : ''} ${fontFamily ? `${fontFamily}-font`: ''}`}
                      >
                        {childItem?.url === 'disabled' ? (
                          <Tooltip
                            title={intl.formatMessage({ id: '"menu.link.disable' })}
                            placement="top"
                          >
                            <div
                              style={{ width: '100%' }}
                              className="header__link-nav-child ant-menu-item-disabled"
                            >
                              <FormattedMessage id={upperCase(childItem.title)} />
                            </div>
                          </Tooltip>
                        ) : (
                          <a
                            className="header__link-nav-child"
                            href={childItem.url}
                            onClick={onClose}
                          >
                            <FormattedMessage id={upperCase(childItem.title)} />
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </SubMenu>) : null}

                {isPrivateWithTokenAccountType && !account?.isCapitalVacations ? (
                  <Menu.Item
                    key={`logout-199`}
                    className="header__user-info-navigation"
                    style={{ marginBottom: '15px' }}
                  >
                    <a
                      href={logoutUrl}
                      className="header__user-drawer-btn-wrapper"
                      style={{ padding: '0px', marginTop: '20px' }}
                      onClick={onClose}
                    >
                      <WhiteButton>
                        <FormattedMessage id="log.out" />
                      </WhiteButton>
                    </a>
                  </Menu.Item>) : null}

                {isPrivateWithLoginAccountType ||
                (hasClientCash && isLogged && !account?.isCapitalVacations) ? (
                  <Menu.Item
                    key={`logout-200`}
                    className="header__user-info-navigation"
                    style={{ marginBottom: '15px' }}
                  >
                    <div
                      className="header__link-nav-child"
                      style={{ padding: '0px' }}
                      onClick={handleLogout}
                    >
                      <FormattedMessage id="log.out" />
                    </div>
                  </Menu.Item>) : null}

                {hasClientCash && !isLogged && !isSignInRoute && !isSignUpRoute ? (
                  <Menu.Item
                    key={`logout-201`}
                    className="header__user-info-navigation"
                    style={{ marginBottom: '15px' }}
                  >
                    <div className="header__link-nav-child">
                      <div className="header__link-nav-child-link" onClick={hangleGoToLogin}>
                        <FormattedMessage id="sign.in" />
                      </div>{' '}
                      <FormattedMessage id="or" />{' '}
                      <div
                        className="header__link-nav-child-link"
                        style={{ marginLeft: '6px' }}
                        onClick={hangleGoToSignUp}
                      >
                        <FormattedMessage id="sign.up" />
                      </div>
                    </div>
                  </Menu.Item>) : null}
              </Menu>
            </div>
          )}
        </Drawer>
      )}
    </div>
  );
}
